import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useSelector } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { propFunc, propStr, ReduxFormProps, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import ModalHoc from '../../../../../../Ui/Modal/ModalHoc';
import DisableModalForm from './DisableModalForm';
const DisableModal = (props) => {
    const { form, handleSubmit, hideModal: rawHideModal, modalState, submitting, } = props;
    const selector = formValueSelector(form);
    const email = useSelector((state) => selector(state, 'email'));
    const hideModal = submitting ? undefined : rawHideModal;
    return (_jsxs("div", Object.assign({ className: `proffit_search_warning_modal disable_account fade_modal animated-opacity ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: hideModal, role: 'presentation' }), _jsx(DisableModalForm, { className: 'modal_box', email: email, handleSubmit: handleSubmit, hideModal: hideModal, submitting: submitting })] })));
};
DisableModal.propTypes = Object.assign({ hideModal: propFunc().isRequired, modalState: propStr().isRequired }, ReduxFormProps);
const enhance = compose(ModalHoc, reduxForm({ form: 'AccountListDisableModal' }));
export default enhance(DisableModal);
